import React, { useMemo } from "react";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { Project } from "fond/types";
import { AccordionStepper, AccordionStepperPane } from "fond/widgets";

import ModificationsPanel from "./ModificationsPanel";
import SettingsPanel from "./SettingsPanel";

interface DataPrepPanelProps {
  project: Project;
  versionId: string;
  /**
   * Flag indicating if the project is read only
   */
  readOnly: boolean;
}

const DataPrepPanel: React.FC<DataPrepPanelProps> = ({ project, versionId, readOnly }: DataPrepPanelProps) => {
  const { workflowState } = useCustomWorkflow({ versionId, key: "planner_extended_data_prep" });

  const accordionPanes: AccordionStepperPane[] = useMemo(
    () => [
      {
        header: "Setup & Generate",
        id: "setup",
        content: <SettingsPanel project={project} />,
        isComplete: workflowState === "COMPLETE",
      },
      {
        header: "Modifications",
        id: "modifications",
        content: <ModificationsPanel />,
        isComplete: false,
        optional: true,
      },
    ],
    [project, workflowState]
  );

  return <AccordionStepper id={`${project.ID}-data-prep`} panes={accordionPanes} autoMove={[""]} variant="outlined" />;
};

export default DataPrepPanel;
